import { render, staticRenderFns } from "./OptionsComfimedRatioTile.vue?vue&type=template&id=1d255190"
import script from "./OptionsComfimedRatioTile.vue?vue&type=script&lang=js"
export * from "./OptionsComfimedRatioTile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports